import './Footer.css';

export default function Footer() {
  return (
    <div className="foot">
      <div className="foot__inner app-col">
        <span className="foot__meta">ctf · v0.4 · 2026</span>
        <span className="foot__status">
          <span className="foot__dot on" aria-hidden />
          system live
        </span>
      </div>
    </div>
  );
}
